import { Input } from '@amigoapp/doca-react';
import { Text, QuestionaryLoading, Button } from '../../components/index.js';
import SignatureCanvas from 'react-signature-canvas';
import { SignatureCanvasContainer, SignatureTypeButton, SignatureTypeWrapper } from './AnesthetistSignatureForm.styles.js';
import { formatCpf } from '../../utils/formatter';

const AnesthetistSignatureForm = ({
	loading,
	variant,
	getCanvasRef,
	canvasOptions,
	isResponsibleAdded,
	handleCheckboxChange,
	handleSubmit,
	clear,
	undo,
	responsible,
	setResponsible
}) => {
	if (loading) {
		return <QuestionaryLoading />;
	}

	return (
		<div className="doca-flex doca-flex-col doca-w-full doca-mx-auto">
			<div className="doca-mb-4 doca-mt-6 doca-px-4">
				<label className="doca-steps__label">Passo 3 de 3</label>

				<div className="doca-steps__container">
					<div className={`doca-steps doca-mr-3 doca-w-full doca-steps--done doca-steps--${variant}`} />
					<div className={`doca-steps doca-mr-3 doca-w-full doca-steps--done doca-steps--${variant}`} />
					<div className={`doca-steps doca-mr-3 doca-w-full doca-steps--current doca-steps--${variant}`} />
				</div>
			</div>

			<div className="doca-px-4">
				<div className="doca-mb-1">
					<Text size="large" weight="medium">
						Assinatura
					</Text>
				</div>

				<div>
					<Text size="small" variant="gray">
						Para finalizar, é necessário coletar a assinatura do paciente.
					</Text>
				</div>
			</div>

			<div className="doca-px-4">
			    <SignatureTypeWrapper>
					<SignatureTypeButton active={true}>
						<i className="doca-icon doca-icon__signature mr-2" />
						Rubrica
					</SignatureTypeButton>
				</SignatureTypeWrapper>

				<SignatureCanvasContainer>
					<SignatureCanvas ref={getCanvasRef} canvasProps={canvasOptions} />
				</SignatureCanvasContainer>

				<div hidden={loading} className="doca-flex doca-mt-2 doca-mb-4">
					<button className="doca-button doca-button--secondary doca-mr-2" onClick={clear}>
						<i className="doca-icon doca-icon__trash" />
						Limpar
					</button>
					<button className="doca-button doca-button--secondary" onClick={undo}>
						<i className="doca-icon doca-icon__undo" />
						Desfazer
					</button>
				</div>

				<div className="doca-py-2">
					<div className="doca-form__field doca-toggle__container">
						<div className="doca-toggle__input-container">
							<input
								className="doca-toggle"
								id="add-responsible"
								type="checkbox"
								checked={isResponsibleAdded}
								onChange={handleCheckboxChange}
							/>
							<label
								className="doca-toggle__switch"
								htmlFor="add-responsible"
							/>
						</div>
						<label className="doca-form__label doca-form__label--inline">
							Adicionar responsável
						</label>
					</div>
				</div>

				{isResponsibleAdded && (
					<div className="doca-mt-2">
						<Input
							label="Nome do responsável"
							placeholder="Digite o nome do responsável do paciente"
							name="name"
							className="doca-mb-4"
							value={responsible.name || ''}
							onChange={(e) => setResponsible({ ...responsible, name: e.target.value })}
						/>

						<Input
							label="CPF"
							name="cpf"
							className="doca-mb-4"
							value={responsible.cpf || ''}
							placeholder="000.000.000-00"
							onChange={(e) => {
								const formattedCpf = formatCpf(e.target.value);
								setResponsible({ ...responsible, cpf: formattedCpf });
							}}
						/>
					</div>
				)}
			</div>

			<div className="doca-mt-6 doca-mb-6 doca-px-4">
				<Button
					block
					size="large"
					variant={variant}
					type="button"
					onClick={handleSubmit}
				>
					Assinar
				</Button>
			</div>
		</div>
	);
};

export default AnesthetistSignatureForm;
